import React from "react";
import { Button } from "tabler-react";
import DatePicker from "react-datepicker";

const LAYOUTS = {
  default: {
    wrapper: "box-al",
    from: "col col-sm-5",
    to: "col col-6 col-sm-5",
    submit: "col col-6 col-sm-2",
  },
  wide: {
    wrapper: "box-al mar-40",
    from: "col col-6 col-sm-4 col-lg-5",
    to: "col col-6 col-sm-4 col-lg-5",
    submit: "col col-6 col-sm-4 col-lg-2",
  },
  compact: {
    wrapper: "box-al mar-40",
    from: "col col-6 col-sm-4 col-lg-3",
    to: "col col-6 col-sm-4 col-lg-3",
    submit: "col col-6 col-sm-4 col-lg-3",
  },
  inline: {
    wrapper: "box-al mar-40 spaceBetweenContainer",
    from: "col",
    to: "col",
    submit: "col",
  },
};

export default function ChartDateRangeForm({
  startDate,
  endDate,
  onStartChange,
  onEndChange,
  onSubmit,
  layout = "default",
}) {
  const classes = LAYOUTS[layout] || LAYOUTS.default;

  return (
    <div className={classes.wrapper}>
      <form
        onSubmit={onSubmit}
        style={layout === "inline" ? { width: "auto" } : undefined}
      >
        <div className="row">
          <div className={classes.from}>
            <label className="form-label">From Date</label>
            <DatePicker
              className="form-control"
              selected={startDate}
              onChange={onStartChange}
              maxDate={new Date()}
              dateFormat="dd/MM/yyyy"
              placeholderText="DD/MM/YYYY"
            />
          </div>
          <div className={classes.to}>
            <label className="form-label">To Date</label>
            <DatePicker
              className="form-control"
              selected={endDate}
              onChange={onEndChange}
              maxDate={new Date()}
              minDate={startDate}
              dateFormat="dd/MM/yyyy"
              placeholderText="DD/MM/YYYY"
            />
          </div>
          <div className={classes.submit}>
            <br />
            <Button color="primary sub1" type="submit">
              Submit
            </Button>
          </div>
        </div>
      </form>
    </div>
  );
}
